import '../scss/main.scss'
import 'aos/dist/aos.css'

import app from './app'

app();
